import $ from 'jquery';
import Reflux from 'reflux';
import IsiActions from './actions';
import Tracking from 'medscape/tracking';
const ContentCache = {};
let isFirstVisit = true;
let isAccepted = false;
let isStickyVisible = false;
export default class IsiStore extends Reflux.Store {
    constructor( props ) {
        super();
        this.props = props;
        this.state = this.getInitialState();
        if(isFirstVisit && props.isSticky){
            this.state.isExpanded = props.isExpanded;
            isFirstVisit = false;
        }
        if(props.isSticky && props.config.isExpanded && props.config.collapseEvent.acceptButton && !isAccepted){
            this.state.isVisible = true;
            this.state.isExpanded = true;
        }
        this.state.isAutoScroll = props.config.isAutoScroll;
        this.listenables = [IsiActions];
    }
    getInitialState() {
        return {
            content: '',
            isExpanded: false,
            scrollTo: false,
            isVisible: true,
            isAccepted: isAccepted,
            isAutoScroll: false,
            isTimerFinished: false
        };
    }
    onGetContentCompleted(content) {
        //const path = props.config.path;
        if(!content){
            return;
        }

        this.setState({
            content: content
        });
    }
    onGetContentFailed(response) {
        //const path = props.config.path;
        console.error("Get ISI Content Error: ",response);
    }
    onAccept(){
        isAccepted = true;
        if(!this.state.isExpanded){
            Tracking.pageLink("isi_accept");
        }
        this.setState({
            isAccepted: true,
            isExpanded: false,
            isAutoScroll: false
        });
    }
    onToggle(isExpanded=!this.state.isExpanded) {
        if(this.props.isSticky && this.state.isVisible){
           const tracking = isExpanded ? "expand" : "collapse";
           if(!isExpanded && !this.state.isExpanded){} else {
            Tracking.pageLink(`isi_${tracking}`);
           }
        }
        this.setState({
            isExpanded: isExpanded,
            isTimerFinished: true,
            isAccepted: true,
            isAutoScroll: false
        });

    }
    onToggleAutoScroll(flag=!this.state.isAutoScroll){
        this.setState({
            isAutoScroll: flag
        });
    }
    onToggleSticky(isVisible=!this.state.isVisible){
        isStickyVisible = isVisible;
        if(this.props.isSticky){
            this.setState({
                isVisible: isVisible
            });
        }
    }
    onLinkClick(){
        if(isStickyVisible){
            this.setState({
                isExpanded: true,
                scrollTo: false
            });
        }
        else{
            this.setState({
                isExpanded: false,
                scrollTo: true
            });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/isi/store.js